import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

class Barcode extends Component {
    render() {
        return (
            <td className='Barcode'>
                {
                    this.props.barcode ? (
                        <Link to={`/order-item?template=${this.props.barcode}`} target='_blank' rel='noopener noreferrer'>
                            {this.props.barcode}
                        </Link>) : '-'
                }
            </td>
        )
    }
}

Barcode.propTypes = {
    barcode: PropTypes.string,
}

export default Barcode
